    import React, { createContext, useState, useContext, useEffect } from 'react';

    const UserContext = createContext(null);

    export const UserProvider = ({ children }) => {

      const [userId, setUserId] = useState(( ) => {
        const xUserId = sessionStorage.getItem('userId');
        return xUserId ? JSON.parse(xUserId) : null;
      });

      const [userName, setUserName] = useState(( ) => {
        const xUserName = sessionStorage.getItem('userName');
        return xUserName ? JSON.parse(xUserName) : null;
      });

      const [userRole, setUserRole] = useState(( ) => {
        const xUserRole = sessionStorage.getItem('userRole');
        return xUserRole ? JSON.parse(xUserRole) : null;
      });

      const [userRegistrationDate, setUserRegistrationDate] = useState(( ) => {
        const xUserRegistrationDate = sessionStorage.getItem('userRegistrationDate');
        return xUserRegistrationDate ? JSON.parse(xUserRegistrationDate) : null;
      });

      const [ccgEmployee, setCcgEmployee] = useState(( ) => {
        const xCcgEmployee = sessionStorage.getItem('ccgEmployee');
        return xCcgEmployee ? JSON.parse(xCcgEmployee) : null;
      });

      const [termsAccepted, setTermsAccepted] = useState(( ) => {
        const xTermsAccepted = sessionStorage.getItem('termsAccepted');
        return xTermsAccepted ? JSON.parse(xTermsAccepted) : false;
      });

      const [eulaAccepted, setEulaAccepted] = useState(( ) => {
        const xEulaAccepted = sessionStorage.getItem('eulaAccepted');
        return xEulaAccepted ? JSON.parse(xEulaAccepted) : false;
      });

      const [authenticated, setAuthenticated] = useState(( ) => {
        const xAuthenticated = sessionStorage.getItem('authenticated');
        return xAuthenticated ? JSON.parse(xAuthenticated) : false;
      });

      useEffect(() => {
        sessionStorage.setItem('userId', JSON.stringify(userId));
      }, [userId]);

      useEffect(() => {
        sessionStorage.setItem('userName', JSON.stringify(userName));
      }, [userName]);

      useEffect(() => {
        sessionStorage.setItem('userRole', JSON.stringify(userRole));
      }, [userRole]);

      useEffect(() => {
        sessionStorage.setItem('ccgEmployee', JSON.stringify(ccgEmployee));
      }, [ccgEmployee]);

      useEffect(() => {
        sessionStorage.setItem('userRegistrationDate', JSON.stringify(userRegistrationDate));
      }, [userRegistrationDate]);

      useEffect(() => {
        sessionStorage.setItem('termsAccepted', JSON.stringify(termsAccepted));
      }, [termsAccepted]);

      useEffect(() => {
        sessionStorage.setItem('eulaAccepted', JSON.stringify(eulaAccepted));
      }, [eulaAccepted]);

      useEffect(() => {
        sessionStorage.setItem('authenticated', JSON.stringify(authenticated));
      }, [authenticated]);
      
      const updateUserId = (id) => {
        setUserId(id);
      };

      const updateUserName = (name) => {
        setUserName(name);
      };

      const updateUserRole = (role) => {
        setUserRole(role);
      };

      const updateCcgEmployee = (employee) => {
        setCcgEmployee(employee);
      };

      const updateUserRegistrationDate = (date) => {
        setUserRegistrationDate(date);
      };

      const updateTermsAccepted = (value) => {
        setTermsAccepted(value);
      };

      const updateEulaAccepted = (value) => {
        setEulaAccepted(value);
      };

      const updateAuthenticated = (value) => {
        setAuthenticated(value);
      };

      const userLogout = () => {
        setUserId(null);
        setUserName(null);
        setUserRole(null);
        setCcgEmployee(null);
        setUserRegistrationDate(null);
        setTermsAccepted(false);
        setEulaAccepted(false);
        setAuthenticated(false);
      };

      return (
        <UserContext.Provider 
            value={{ 
                userId, userName, userRole, ccgEmployee, userRegistrationDate, termsAccepted, eulaAccepted, authenticated, 
                updateUserId, updateUserName, updateUserRole, updateCcgEmployee, updateUserRegistrationDate, userLogout, updateTermsAccepted, updateEulaAccepted, updateAuthenticated 
            }}
        >
            {children}
        </UserContext.Provider>
      );
    };

    export const useUser = () => useContext(UserContext);